export function getDayName(num) {
  const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
  if (num === 0) return days.pop()
  return days[num - 1]
}


// WEBPACK FOOTER //
// ./src/components/Main/utils.js